{
  "search": "Suchen",
  "login": "Benutzername",
  "firstname": "Vorname",
  "lastname": "Nachname",
  "email": "E-Mail-Adresse",
  "addUserGroup": "Gruppe hinzufügen",
  "selectUserProfile": "Profil auswählen",
  "profile": "Profil",
  "userProfile": "Profil des Benutzers",
  "language": "Sprache",
  "label": "Name",
  "error": {
    "required": "Pflichtfeld",
    "maxLength": "Maximale Länge: {maxLength}",
    "invalidFormat": "Ungültiges Format",
    "lowercaseOnly": "Nur Kleinbuchstaben werden akzeptiert"
  },
  "url": "URL",
  "deleteFile": "Klicken, um die Datei zu löschen",
  "password": "Passwort",
  "nominalTemplateName": "Name der nominalen Vorlage",
  "bootstrapTemplateName": "Name der Bootstrap-Vorlage",
  "secondIntervalTime": "Intervallzeit (Sekunden)",
  "profileName": "Profilname",
  "languages": {
    "en": "Englisch (English)",
    "fr": "Französisch (Français)",
    "it": "Italienisch (Italiano)",
    "es": "Spanisch (Español)",
    "de": "Deutsch"
  },
  "passwordPlaceholder": "**********",
  "clickToUpload": "Klicken, um hochzuladen",
  "orDragAndDrop": "oder ziehen Sie die Datei {format} nur per Drag-and-Drop",
  "orDragAndDropWithoutExtension": "oder ziehen und ablegen",
  "information": {
    "more": "Weitere Informationen anzeigen"
  },
  "select": {
    "search": {
      "placeholder": "Suchen",
      "noResults": "Keine Ergebnisse"
    }
  },
  "timezone": {
    "placeholder": "Zeitzone auswählen"
  },
  "selectAll": "Alle auswählen",
  "optional": "Optional"
}
